module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/minimalist-83ae8823a4f938557a4c3e05f70f6c94.jpg";